import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { Icon, Box, Flex, Text, useToast, Button, Image } from '@chakra-ui/react'
import { DragAndDrop } from '../../../components/DragAndDrop'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { api } from '../../../services/api'
import { useMutation } from 'react-query'

const archieveSchema = yup.object().shape({
  files: yup.mixed().required('Arquivo é obrigatório'),
})

async function uploadArchieve(data) {
  const response = await api.post('/asia/atualizacao-fornecedor', data)

  return response.data
}

export function AtualizacaoProdutosAsiaSP() {
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    resetField,
  } = useForm({
    resolver: yupResolver(archieveSchema),
  })

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const { data, mutateAsync, isLoading, isError } = useMutation({
    mutationFn: uploadArchieve,
    onSuccess: () => {
      toast({
        title: 'Arquivo enviado com sucesso',
        status: 'success',
      })

      resetField('files')
    },
    onError: (error) => {
      toast({
        title: 'Erro ao enviar arquivo',
        description: error.response.data.erros.join(', '),
        status: 'error',
      })
    },
  })

  console.log(data)

  async function onSubmit(data) {
    console.log(data.files)
    const formData = new FormData()
    formData.append('planilha', data.files)

    await mutateAsync(formData)
  }

  return (
    <>
      <HeadingPages name="Atualização Produtos ASIA SP" />
      <Layout>
        <Flex direction="column" align="center" justify="center" w="100%" h="100%">
          <Box as="form" onSubmit={handleSubmit(onSubmit)} w="100%" maxW="500px" h="100%" p="4" borderRadius="md" boxShadow="md">
            <DragAndDrop control={control} errors={errors} />

            <Button disabled={!isDirty} type="submit" colorScheme="blue" mt="4" isLoading={isLoading}>
              Enviar
            </Button>
          </Box>

          {data && (
            <Box mt="8">
              <Text fontSize="md" fontWeight="bold" color="gray.600" mb="4">
                Retorno:
              </Text>
              <Box w="100%" display="flex" flexWrap="wrap" gap={2} h="100%" p="4" borderRadius="md" boxShadow="md">
                {data?.codparc_fornecedor?.map((item) => (
                  <Box
                    boxShadow="sm"
                    border="1px solid gray.200"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    p="2"
                    borderRadius="md"
                    bg="gray.100"
                    color="gray.600"
                    key={item}
                  >
                    {item}
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </Flex>
      </Layout>
    </>
  )
}
